import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { updateRoleName } from 'api/userGroups.service';
import { userGroupsKeys } from './queryKeys';

export const useUpdateRoleNameQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate, data } = useMutation({
    mutationFn: (info: { roleId: string; newName: string }) => {
      setLoading();

      return updateRoleName(info.roleId, info.newName);
    },
    onSuccess: () => {
      toast.success('Role name has been updated successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      removeLoading();
      queryClient.invalidateQueries({ queryKey: userGroupsKeys.all });
    },
  });

  return { isLoading: isPending, mutate, data };
};
